import { countTagByTag } from '../queries/countTagByTag'

export const tagCountByTagGauge = {
  id: 'tagCountByTagGauge',
  queries: [countTagByTag],
  title: 'Tag usage',
}
